'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 0px;\n  width: 104px;\n  height: 15px;\n  border-radius: 8px;\n'], ['\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 0px;\n  width: 104px;\n  height: 15px;\n  border-radius: 8px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rebass = require('rebass');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Notch = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);

var Phone = function Phone(_ref) {
  var _ref$src = _ref.src,
      src = _ref$src === undefined ? 'https://via.placeholder.com/187x406' : _ref$src,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'grey' : _ref$color,
      notch = _ref.notch,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['src', 'style', 'color', 'notch', 'children']);

  return _react2.default.createElement(_rebass.Box, _extends({
    bg: color,
    px: '1%',
    py: notch ? 8 : '4%',
    style: _extends({
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,.6), 0 22px 70px 4px rgba(0,0,0,0.56), 0 0 0 1px rgba(0, 0, 0, 0.3)',
      borderRadius: 20,
      position: 'relative'
    }, style)
  }, props), notch && _react2.default.createElement(Notch, {
    bg: color
  }), src ? _react2.default.createElement(_rebass.Image, {
    src: src,
    style: {
      borderRadius: 16
    }
  }) : children);
};

Phone.displayName = 'Phone';
Phone.propTypes = {
  src: _propTypes2.default.string,
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  notch: _propTypes2.default.bool,
  children: _propTypes2.default.any
};
exports.default = Phone;